var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { giveawaySectionStyles } from 'root/src/client/web/giveaway/features/GiveawaySection/styles/giveawayStyles';
import isOwnProfileSelector from 'root/src/client/logic/creatorData/selectors/isOwnProfileSelector';
import displayModal from 'root/src/client/logic/modal/actions/displayModal';
import { giveawayModuleIds } from 'root/src/client/web/giveaway/descriptions/modules/moduleIds';
import { useAppDispatch, useAppSelector, } from 'root/src/client/logic/helpers/useStore';
import { RedeemModal } from 'root/src/client/web/giveaway/features/RedeemModal/RedeemModal';
import { useMemo, useState, } from 'react';
import { useCreatorActiveGiveaway, useCreatorGiveaways, useCreatorGiveawayScheduler, useCreatorRewards, useGiveawayTerms, useIsCreatorGiveawaysLoading, } from 'root/src/client/web/giveaway/hooks/useCreatorGiveaways';
import { useGiveawayApi } from 'root/src/client/web/giveaway/hooks/useGiveawayApi';
import { useCreatorDataApi } from 'root/src/client/logic/api/hooks/useCreatorDataApi';
import { ActionStrategyId, GiveawayStatus } from '@daredrop-com/rewards-api-contract';
import { useIsAuthenticated } from 'root/src/client/v2/auth/hooks/useIsAuthenticated';
import { SIGN_IN_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds';
import { useBetween } from 'use-between';
import { useGiveawayTermsCheckbox, } from 'root/src/client/web/giveaway/features/GiveawaySection/hooks/useGiveawayTermsCheckbox';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import { CreateGiveawayModalLegacyWrapper, } from 'root/src/client/web/giveaway/features/CreateGiveawayModal/components/CreateGiveawayModalLegacyWrapper';
import toast from 'react-hot-toast';
import { giveawayAnalyticsEvents, VerifySteamStage, } from 'root/src/shared/giveaways/giveaways.constants';
import VerifySteamModal from 'root/src/client/web/giveaway/features/VerifySteamModal/VerifySteamModal';
import analyticsSendItem from 'root/src/client/logic/analytics/util/analyticsSendItem';
import { useUserId } from 'root/src/client/v2/auth/hooks/useUserId';
import { useBrowserNotification } from 'root/src/client/v2/common/hooks/useBrowserNotification';
export const useGiveawaySection = () => {
    const classes = giveawaySectionStyles();
    const dispatch = useAppDispatch();
    const { userId } = useUserId();
    const isCreatorProfile = useAppSelector(isOwnProfileSelector);
    const giveaways = useCreatorGiveaways();
    const giveaway = useCreatorActiveGiveaway();
    const giveawayApi = useGiveawayApi();
    const creatorDataApi = useCreatorDataApi();
    const giveawayRewards = useCreatorRewards();
    const isAuthenticated = useIsAuthenticated();
    const giveawayTerms = useGiveawayTerms();
    const giveawayScheduler = useCreatorGiveawayScheduler();
    const { isGiveawayTermsCheckboxSelected } = useBetween(useGiveawayTermsCheckbox);
    const [isGiveawayTermsLoading, setIsGiveawayTermsLoading] = useState(false);
    const isLoading = useIsCreatorGiveawaysLoading();
    const isPickingWinner = (giveaway === null || giveaway === void 0 ? void 0 : giveaway.status) === GiveawayStatus.Active && giveaway.endDate && new Date(giveaway.endDate) <= new Date();
    // Check if waiting for participants and wait time has expired
    const isWaitTimeExpired = useMemo(() => {
        var _a;
        if (!giveaway || giveaway.status !== GiveawayStatus.Active)
            return false;
        const { minParticipantsToStart, maxWaitTime } = (_a = giveaway.config) !== null && _a !== void 0 ? _a : {};
        // Only applies when waiting for min participants (endDate is null)
        if (minParticipantsToStart === null || minParticipantsToStart === undefined || giveaway.endDate)
            return false;
        if (!maxWaitTime || !giveaway.startDate)
            return false;
        const waitDeadline = new Date(giveaway.startDate).getTime() + maxWaitTime;
        return Date.now() >= waitDeadline;
    }, [giveaway]);
    const modal = useModal();
    const hasRewards = useMemo(() => {
        return Boolean(giveawayRewards === null || giveawayRewards === void 0 ? void 0 : giveawayRewards.length);
    }, [giveawayRewards]);
    const isGiveawayTermsVisible = giveaway && isAuthenticated && !giveawayTerms;
    const canEnter = giveaway && (giveaway.isSteamEntered || giveaway.isSMSEntered);
    const onCreateGiveaway = () => {
        modal.show(<CreateGiveawayModalLegacyWrapper />);
    };
    const openRedeemVouchersModal = () => {
        modal.show(<RedeemModal />);
    };
    const onGiveawayTermsAccept = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsGiveawayTermsLoading(true);
        try {
            yield giveawayApi.saveGiveawayTerms();
        }
        catch (err) {
            console.error(err);
        }
        setIsGiveawayTermsLoading(false);
    });
    const { requestPermission } = useBrowserNotification();
    const [isSteamLoading, setIsSteamLoading] = useState(false);
    const signIntoSteam = (event) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!isAuthenticated) {
            dispatch(displayModal(SIGN_IN_MODAL_MODULE_ID));
            return;
        }
        if (isGiveawayTermsVisible && !isGiveawayTermsCheckboxSelected) {
            toast.error('Please accept the giveaway terms to proceed.');
            return;
        }
        const steamAction = (_a = giveaway === null || giveaway === void 0 ? void 0 : giveaway.actions) === null || _a === void 0 ? void 0 : _a.find(action => action.strategyId === ActionStrategyId.EnterGiveawaySteam);
        if (!steamAction || !giveaway)
            return;
        // Open popup synchronously from click handler to preserve user gesture chain (required by Mobile Safari)
        const popup = giveawayApi.openSteamPopup(event);
        setIsSteamLoading(true);
        try {
            yield giveawayApi.submitSteamEntry(popup, {
                actionId: steamAction.id,
                giveawayId: giveaway.id,
            });
            yield onGiveawayTermsAccept();
            analyticsSendItem(giveawayAnalyticsEvents.SUBMIT_STEAM_ENTRY_SUCCESS, userId);
            void requestPermission();
            modal.show(<VerifySteamModal stage={VerifySteamStage.SUCCESS}/>);
        }
        catch (err) {
            if (!popup.closed)
                popup.close();
            if (err instanceof Error && err.message === 'Steam sign-in popup closed') {
                setIsSteamLoading(false);
                return;
            }
            const error = err;
            modal.show(<VerifySteamModal stage={VerifySteamStage.ERROR} error={error.message || 'Something went wrong'} code={error.code}/>);
        }
        finally {
            setIsSteamLoading(false);
        }
    });
    const stats = useMemo(() => {
        var _a;
        return {
            totalEntries: (_a = giveaway === null || giveaway === void 0 ? void 0 : giveaway.stats) === null || _a === void 0 ? void 0 : _a.entryCount,
            userEntries: (giveaway === null || giveaway === void 0 ? void 0 : giveaway.isEntered) ? giveaway.actions.reduce((acc, action) => {
                return acc + action.entries.length * action.score;
            }, 0) : 0,
        };
    }, [giveaway]);
    const enterGiveaway = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!giveaway || giveaway.isEntered)
            return;
        const { error } = yield giveawayApi.enterGiveaway({
            giveawayId: giveaway.id,
        });
        if (!error) {
            yield creatorDataApi.fetchGiveaways();
        }
    });
    const displayGiveawayTermsModal = () => {
        dispatch(displayModal(giveawayModuleIds.GIVEAWAY_TERMS_CONDITION_MODAL_MODULE_ID));
    };
    return {
        classes,
        hasRewards,
        isCreatorProfile,
        giveaways,
        isLoading,
        giveaway,
        stats,
        isActive: Boolean((giveaway === null || giveaway === void 0 ? void 0 : giveaway.status) === GiveawayStatus.Active),
        isEntered: Boolean(giveaway === null || giveaway === void 0 ? void 0 : giveaway.isEntered),
        isSteamEntered: Boolean(giveaway === null || giveaway === void 0 ? void 0 : giveaway.isSteamEntered),
        isSMSEntered: Boolean(giveaway === null || giveaway === void 0 ? void 0 : giveaway.isSMSEntered),
        canEnter,
        onCreateGiveaway,
        openRedeemVouchersModal,
        signIntoSteam,
        isSteamLoading,
        enterGiveaway,
        isAuthenticated,
        isGiveawayTermsVisible,
        onGiveawayTermsAccept,
        isGiveawayTermsLoading,
        displayGiveawayTermsModal,
        giveawayScheduler,
        isPickingWinner,
        isWaitTimeExpired,
        refetchGiveaways: creatorDataApi.fetchGiveaways,
    };
};
